import React, { useContext } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { UserContext } from 'commons-ui';

interface IPublicRouteProps {
	path: any;
	component: any;
	exact: boolean;
}

const PublicRoute: React.FC<IPublicRouteProps> = ({ path, component, exact }) => {
	const { isLoggedIn, user } = useContext(UserContext);
	const location = useLocation();
	const redirectURL = _get(location, ['state', 'referrer'], '/home');
	if (!isLoggedIn || _isEmpty(user)) {
		return <Route exact={exact} path={path} component={component} />;
	}
	return <Redirect to={redirectURL} />;
};

export default PublicRoute;
